<template>
  <div class="newx_box2">
    <common-top :commonTopData="commonTopData"></common-top>
    <nav-top :value="onNav" :btns="btns" v-model="onNav"></nav-top>
    <component v-bind:is="onNav"></component>
  </div>
</template>
<script>
import commonTop from "@/components/commonTop.vue";
import navTop from "../item3/nav_top.vue";
import bannerList from "./bannerList.vue";
import showList from "./showList.vue";
export default {
  components: {
    commonTop,
    navTop,
    bannerList,
    showList,
  },
  data() {
    return {
      commonTopData: {
        commonleftbtn: [],
      },
      onNav: "showList",
      btns: [{ label: "展示位", value: "showList", path: "/art/item5?tabs=" }],
    };
  },
  created() {},
  methods: {},
};
</script>
<style >
.newx_box2 {
  position: relative;
  height: calc(100% - 60px);
  overflow: hidden;
  overflow-y: auto;
}
</style>

<style >
.container .el-tabs__header {
  margin: 0;
  padding: 0;
  position: relative;
  margin: 0 0 15px;
  position: absolute;
  top: -72px;
  left: 50%;
  transform: translateX(-50%);
  width: 600px;
}
</style>